import React, { ReactNode } from "react";
import { connect } from "react-redux";
import { createSelector } from "reselect";
import { LDFlags } from "interfaces/context";
import { selectFeatureFlags } from "store/select/context";
import { IRootStateProps } from "types/reducers";

interface IPropsFromState {
  featureFlags: LDFlags;
}

interface IRenderForFlag {
  children: ReactNode;
  flag: string;
}

// A component to render children in response to enabled flag
const FlagRenderSwitcher = ({
  children,
  flag,
  featureFlags,
}: IRenderForFlag & IPropsFromState) => {
  const key = flag as keyof LDFlags;

  if (featureFlags[key]) {
    return <>{children}</>;
  }

  return null;
};

const mapStateToProps = createSelector(
  selectFeatureFlags,
  (featureFlags): IPropsFromState => {
    return {
      featureFlags,
    };
  }
);

const RenderForFlag = connect<
  IPropsFromState,
  {},
  IRenderForFlag,
  IRootStateProps
>(mapStateToProps)(FlagRenderSwitcher);

export default RenderForFlag;
